export const CLEAR_SEARCH_FREELANCERS = "Freelancers/CLEAR_SEARCH_FREELANCERS";

export const EMPTY_FREELANCERS = "Freelancers/EMPTY_FREELANCERS";

export const SEARCH_FREELANCERS = 'Freelancers/SEARCH_FREELANCERS';
export const SEARCH_FREELANCERS_SUCCESS = 'Freelancers/SEARCH_FREELANCERS_SUCCESS';
export const SEARCH_FREELANCERS_FAILURE = 'Freelancers/SEARCH_FREELANCERS_FAILURE';

export const SET_FREELANCERS_SEARCH_FIELD = 'Freelancers/SET_FREELANCERS_SEARCH_FIELD';
export const SET_FREELANCERS_FILTERS = 'Freelancers/SET_FREELANCERS_FILTERS';


// WEBPACK FOOTER //
// ./src/containers/Freelancers/store/constants.js